import BaseUrl from "../component/BaseUrl";

export const get = async (search) => {
    try {
        const config = {
            headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem('pacificadmin'))?.token?.token}` }
        };
        const response = await BaseUrl.get(`/api/Lessons/GetLessons?dayNumber=${search}`, config);
        return response;
    } catch (err) {
        return err.response
    }
}

export const uploadFile = async (body) => {
    try {
        
        const config = {
            headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem('pacificadmin'))?.token?.token}` }
        };
        const response = await BaseUrl.post("/api/Lessons/UploadLessonFile", body, config);
        return response;
    } catch (err) {
        return err.response
    }
}

export const addLesson = async (body) => {
    try {
        const config = {
            headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem('pacificadmin'))?.token?.token}` }
        };
        const response = await BaseUrl.post("/api/Lessons/SaveLesson", body, config);
        return response;
    } catch (err) {
        return err.response
    }
}

export const getLessonbyId = async (id) => {
    try {
        const config = {
            headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem('pacificadmin'))?.token?.token}` }
        };
        const response = await BaseUrl.get(`/api/Lessons/GetLessonById/${id}`, config);
        return response;
    } catch (err) {
        return err.response
    }
}

export const updateLesson = async (body) => {
    try {
        const config = {
            headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem('pacificadmin'))?.token?.token}` }
        };
        const response = await BaseUrl.put(`/api/Lessons/UpdateLesson`, body, config);
        return response;
    } catch (err) {
        return err.response
    }
}

export const deleteLesson = async (id) => {
    try {
        const config = {
            headers: { Authorization: `Bearer ${JSON.parse(localStorage.getItem('pacificadmin'))?.token?.token}` }
        };
        const response = await BaseUrl.delete(`/api/Lessons/DeleteLesson/${id}`, config);
        return response;
    } catch (err) {
        return err.response
    }
}